module.exports = __webpack_public_path__ + "static/media/Scope-4.585a29d3.png";